import {
  BoxRegroupSuccessResponseSchema,
  type BoxItemRegroupInput,
  type BoxRegroupSuccessResponse,
} from '@magimp/shared';
import { request } from '../client.js';

/**
 * @aiPurpose narrow PATCH wrapper for the China-side regroup endpoint
 *   (#1178, §6). Sends the batch in a single request and forwards the
 *   `If-Match` precondition as a raw ISO string (D7 — not a quoted ETag).
 * @aiInvariant `ifMatch` is the parent box's `RequestBox.updatedAt` ISO,
 *   sourced from a `?includeBoxVersions=true` read. Stale-bundle clients
 *   never call this function because they never receive the version
 *   field; the regroup edit toggle is hidden when `updatedAt` is absent.
 */
export function regroupBoxItems(
  requestId: string,
  boxId: string,
  ifMatch: string,
  items: ReadonlyArray<BoxItemRegroupInput>,
): Promise<BoxRegroupSuccessResponse> {
  return request<BoxRegroupSuccessResponse>(
    `/requests/${encodeURIComponent(requestId)}/boxes/${encodeURIComponent(boxId)}/items/group-ordinals`,
    {
      method: 'PATCH',
      body: JSON.stringify({ items }),
      headers: {
        'content-type': 'application/json',
        'if-match': ifMatch,
      },
    },
    {},
    BoxRegroupSuccessResponseSchema,
  );
}
